import { Divider, Grid, Typography } from '@methanesat/ui-components';
import { DrawerCard } from '../../DrawerWithCards/DrawerCard';
import { useTranslate } from '../../../../../hooks';

/**
 * The drawer of information when clustered infrastructure is selected.
 */
export const ClusteredInfrastructureCard = ({ count, type }: { count: number; type: string }) => {
    const t = useTranslate();

    return (
        <DrawerCard
            data-active={''}
            data-testid="target-drawer-card"
            elevation={0}
            sx={{
                '&:not(:last-child)': {
                    marginBottom: 3
                }
            }}
        >
            {/* Header */}
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h5" sx={{ display: 'inline' }}>
                        {t('emissionsMapPage.mapModals.infrastructure.clusteredTitle')}
                    </Typography>
                </Grid>
            </Grid>
            <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
            {/* Body */}
            <Typography>
                {t('emissionsMapPage.mapModals.infrastructure.clusteredBody', {
                    count,
                    type: t(`emissionsMapPage.infrastructure.categoriesPlural.${type}`).toLowerCase()
                })}
            </Typography>
        </DrawerCard>
    );
};
